import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Justify, SelectOptionWithGroup } from 'tea-component';
import MultiTypeDownloadBtn from '@intelligence/pages/TopCharts/components/MultiTypeDownloadBtn';
import IconButton from '@gp/components/IconButton';
import ConfirmableBtn from '@gp/components/ConfirmableBtn';
import PublishButton from '@gp/components/PublishButton';
import GPSelect from '@gp/components/Select';
import DPSReportEmailSender from '../EmailSender';
import { getDPSReportWeekLabel } from '@gp/pages/Pipeline/DPSReport/utils';
import { BoolFlag } from '@gp/enums/common';
import { DOWNLOAD_TYPES } from '../../constants';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportBaseVO } from '@gp/types/dpsReport/common';

export interface IReviewReportFilter {
  id: string;
}

interface IReviewReportFilterProps extends IBaseProps {
  node: React.RefObject<HTMLDivElement | null>;
  // 是否有新增、编辑、删除权限 通用操作权限
  hasPermission?: boolean;
  // 是否可编辑，GPOP维护的周报可以编辑，管理端上传的周报不能在GPOP编辑
  isEditable?: boolean;
  isReportImgsLoading?: boolean;
  isDownloading?: boolean;
  reports?: IDPSReportBaseVO[] | null;
  reportOptions: SelectOptionWithGroup[];
  isPublish?: BoolFlag;
  dateTitle?: string;
  subTitle?: string;
  report?: IDPSReportBaseVO | null;
  value: IReviewReportFilter;
  onChange: (value: IReviewReportFilter) => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onPublish?: (payload: BoolFlag) => void;
  onDownload?: (payload: string) => void;
}

const PUBLISH_BUTTON_STYLES = { width: 184, justifyContent: 'center' };

const ReviewReportFilter: React.FC<IReviewReportFilterProps> = (props) => {
  const {
    style,
    className,
    node,
    hasPermission = false,
    isEditable = false,
    isReportImgsLoading,
    isDownloading,
    reports,
    reportOptions,
    isPublish = BoolFlag.False,
    dateTitle,
    subTitle,
    report,
    value: valueProps,
    onChange,
    onEdit,
    onDelete,
    onPublish,
    onDownload,
  } = props;

  const [value, setValue] = useState(valueProps);

  const handleChange = (key: string, payload: string) => {
    const valueTmp = { ...value, [key]: payload };
    setValue(valueTmp);
    onChange(valueTmp);
  };

  const handleDelete = () => {
    onDelete?.();
  };

  useEffect(() => {
    setValue({ ...value, ...valueProps });
  }, [valueProps]);

  return (
    <Justify
      style={style}
      className={classnames(
        'dbg-dps-report__filter dbg-common-btn-div',
        className,
      )}
      left={
        <>
          <GPSelect
            style={{ width: 328 }}
            clearable={false}
            optionTextRenderer={(option) => {
              const { value } = option || {};
              const report = reports?.find((item) => item?.id === value);
              return getDPSReportWeekLabel(report!);
            }}
            options={reportOptions}
            value={value?.id}
            onChange={(payload) => {
              handleChange('id', payload);
            }}
          />
          {hasPermission && (
            <>
              {isEditable && (
                <IconButton
                  className="dbg-common-white-btn"
                  type="text"
                  onClick={onEdit}
                >
                  Edit
                </IconButton>
              )}
              {/* 发送邮件 */}
              <DPSReportEmailSender
                disabled={isReportImgsLoading}
                node={node}
                dateTitle={dateTitle}
                subTitle={subTitle}
                report={report}
              />
              <ConfirmableBtn
                // 二次确认弹窗的标题
                confirmTitle="Do you want to delete this newsletter?"
                // 二次确认弹窗的描述
                confirmDescription="The deleted information will not be recovered."
                // @ts-ignore
                confirmModalCfg={{ size: 528 }}
                // 二次确认弹窗点击confirm的回调
                onConfirm={handleDelete}
              >
                <IconButton className="dbg-common-white-btn" type="text">
                  Delete Newsletter
                </IconButton>
              </ConfirmableBtn>
              <PublishButton
                style={PUBLISH_BUTTON_STYLES}
                className="dbg-common-white-btn"
                type="text"
                value={isPublish}
                onChange={onPublish}
              />
            </>
          )}
        </>
      }
      right={
        <MultiTypeDownloadBtn
          isDisabled={isReportImgsLoading}
          isLoading={isDownloading}
          options={DOWNLOAD_TYPES}
          onSelect={onDownload}
        />
      }
    />
  );
};

export default ReviewReportFilter;
